module.exports = __webpack_public_path__ + "static/media/icon_radio.ff82eaaa.svg";